import React from 'react';

type Props = {} & React.SVGProps<SVGSVGElement>;

const SmileyGood = (props: Props): JSX.Element => {
  return (
    // @ts-ignore
    <svg
      viewBox="0 0 35 35" {...props}
    >
      <path
        d="M17.5.247C7.972.247.247 7.972.247 17.5S7.971 34.753 17.5 34.753 34.753 27.028 34.753 17.5 27.028.247 17.5.247zm5.128 9.617a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm-10.256-.283a3.219 3.219 0 110 6.437 3.219 3.219 0 010-6.437zm14.376 12.564c-.144.172-3.602 4.217-8.791 4.441-3.358.144-6.593-1.324-9.635-4.366a1.176 1.176 0 111.664-1.664c2.55 2.55 5.191 3.781 7.849 3.679 4.147-.169 7.084-3.572 7.113-3.607a1.177 1.177 0 011.8 1.517z"
      />
    </svg>
  );
};

export default SmileyGood;
